var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons - small"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 2.5H3C2.72386 2.5 2.5 2.72386 2.5 3V12.5C2.5 12.7761 2.72386 13 3 13H12.5C12.7761 13 13 12.7761 13 12.5V3C13 2.72386 12.7761 2.5 12.5 2.5ZM3 1C1.89543 1 1 1.89543 1 3V12.5C1 13.6046 1.89543 14.5 3 14.5H12.5C13.6046 14.5 14.5 13.6046 14.5 12.5V3C14.5 1.89543 13.6046 1 12.5 1H3Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33333 4.25C9.74755 4.25 10.0833 4.58579 10.0833 5V7C10.0833 7.41421 9.74755 7.75 9.33333 7.75C8.91912 7.75 8.58333 7.41421 8.58333 7V6.75H4V5.25H8.58333V5C8.58333 4.58579 8.91912 4.25 9.33333 4.25ZM12 6.75H10.2222V5.25H12V6.75ZM6.66667 8.25C7.08088 8.25 7.41667 8.58579 7.41667 9V11C7.41667 11.4142 7.08088 11.75 6.66667 11.75C6.25245 11.75 5.91667 11.4142 5.91667 11V10.75H4V9.25H5.91667V9C5.91667 8.58579 6.25245 8.25 6.66667 8.25ZM12 9.25V10.75H7.55556V9.25H12Z",
    fill: "#969696"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.0c7f09630e0e67da2179878f6efdc3d6.svg";
export { ForwardRef as ReactComponent };